<template>
  <font size="20px;">网站创建中</font>
</template>

<script>
import kkUtil from "../../assets/js/kk-util";

export default {
  name: "fake-home",
  data() {
  },
  methods: {},
  components: {},
  beforeCreate() {
    let branchId = kkUtil.getQueryStr('tgId');
    if (branchId) {
      window.location.href = window.location.protocol + "//" + window.location.host + "/home" + "?tgId=" + branchId;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/layer1/fake-home.vue